import { isIsbn } from '../../../../../util/validate';

export const titleTagRegExGlobal = /@\[.*?\]\(.*?\)/g;
export const titleTagRegExGrouped = /(@\[(.*?)]\((.*?)\))/;

// titleTag format: @[Title](ISBN)

export const parseAndValidateTitleTag = titleTag => {
	const parsedTitle = titleTag.match(titleTagRegExGrouped)[2];
	const parsedIsbn = titleTag.match(titleTagRegExGrouped)[3];
	const isValidIsbn = isIsbn(parsedIsbn);
	return { parsedTitle, parsedIsbn, isValidIsbn };
};
